import type { FC } from 'react';

import { HorizontalStepper } from './horizontal-stepper';
import { NestedStepper } from './nested-stepper';
import type { StepperProps } from './types';

const Stepper: FC<StepperProps> = (props) =>
  props.layout === 'nested' ? <NestedStepper {...props} /> : <HorizontalStepper {...props} />;

Stepper.displayName = 'Stepper';

export default Stepper;
